import React from 'react'
import Navbar from '../Home/Navbar';
import Footer from '../Home/Footer';
import HeaderAbout from './HeaderAbout';
import SectionAbout from './SectionAbout';
import QualityAbout from './QualityAbout';

function About() {
  return (
    <div>
        <Navbar/>
        <HeaderAbout/>
        <SectionAbout/>
        <QualityAbout/>
        <Footer/>
    </div>
  )
}

export default About;